import { render, staticRenderFns } from "./SyslogDeleteModal.vue?vue&type=template&id=132d8b7c&"
import script from "./SyslogDeleteModal.vue?vue&type=script&lang=js&"
export * from "./SyslogDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports